"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("@material-ui/core/Icon"));
require("./SFTooltip.css");
var moduleName = 'simplifeye-tooltip';
function SFTooltip(_a) {
    var text = _a.text, _b = _a.type, type = _b === void 0 ? 'click' : _b, children = _a.children;
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    function openTooltip() {
        setIsOpen(true);
    }
    function closeTooltip() {
        setIsOpen(false);
    }
    function toggleTooltip() {
        setIsOpen(function (prevOpen) { return !prevOpen; });
    }
    return (React.createElement("div", { className: moduleName },
        type === 'hover' ? (React.createElement("div", { className: moduleName + "__children", onMouseEnter: openTooltip, onMouseLeave: closeTooltip }, children)) : (React.createElement("div", { className: moduleName + "__children", onClick: toggleTooltip }, children)),
        isOpen && (React.createElement("div", { className: moduleName + "__popover", role: "tooltip" },
            type === 'click' && React.createElement(Icon_1.default, { onClick: closeTooltip }, "close"),
            text))));
}
exports.default = SFTooltip;
